<template>
  <GlobalAlertWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="110px" label-suffix="：" inline>
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称" v-trim/>
      </el-form-item>
      <el-form-item label="色值" prop="param"  >
        <div style="display: flex" class="paperview-input-text">
          <span   v-if="form.name" :title="form.param"   :style="'padding:0px 10px; cursor:pointer;height:28px;line-height: 28px;display: inline-block;width:auto;border:1px solid '+form.param+'; color:'+form.param+';border-radius:5px;'">{{form.name}}</span>
          <el-input style="width: 50px;border: none;outline:none; "  type="color" v-model="form.param" placeholder="请输入色值" v-trim/>
        </div>
      </el-form-item>
      <el-form-item label="排序码(升序)" prop="sortnum">
        <el-input v-model="form.sortnum" type="number" placeholder="请输入排序码" v-trim/>
      </el-form-item>

    </el-form>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
export default {
  name: 'OperaLabelKnowledgeWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        name: '',
        module: 0,
        type: 9,
        sortnum: '',
        param: '#000000'
      },
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入名称', tigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/business/labels',
      'field.id': 'id'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";
::v-deep .el-select {
  width: 100%;
  .el-input__inner {
    width: 100%;
  }
}
::v-deep .paperview-input-text .el-input__inner {
  -webkit-appearance: none;
  border: 0px !important;//改成0，边框就消失了！
}
</style>
